<template>
<div class="vx-col w-full lg:w-1/4 sm:w-1/2 mb-base" style="width:100% !important; margin-bottom:5px !important;">
  <div class="text-center" style="height:50px; box-shadow: 0px 5px 10px 0px rgb(0 0 0 / 10%); border-radius:8px; padding:5px;" v-if="examInfo" scrollHeight>
    <div class="text-center">
      <div class="vx-row justify-end">
        <div style="width: 100%;">
          <div style="display:flex; justify-content:space-between; padding:0 15px">
            <vs-button color="primary" type="flat" style="font-size: 15px; padding:10px; text-align:center; text-overflow: ellipsis; overflow: hidden; white-space: nowrap;" @click="showExam()"><strong>{{examInfo.test_name}}</strong></vs-button>
            <p>{{examInfo.people_num}}</p>
            <div class="flex justify-center flex-wrap" style="margin-top:5px;">
              <vs-button color="primary" style="margin-right:3px" type="border" icon-pack="feather" size="small" icon="icon-list" @click="showInfo(examInfo)"></vs-button>
              <vs-button color="success" style="margin-right:3px" type="border" icon-pack="feather" size="small" icon="icon-plus" @click="setExam(examInfo)"></vs-button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div>
    </div>
  </div>
</div>
</template>


<script>
import { ChevronRightIcon } from 'vue-feather-icons'
export default {
  props: ['examInfo'],
  components: {
    ChevronRightIcon
  },
  data() {
    return {
      nextExamList: []
    }
  },
  created() {
    if(!this.examInfo){
      return
    }
    console.log(this.examInfo)
  },
  methods: {
    showExam() {
      this.$store.commit('etest/ACTIVE_EXAML', this.examInfo)
      this.$router.push('/apps/etest/editer/0')
    },
    showInfo(val) {
      console.log(this.examInfo)
      this.$emit('show' , val)
    },
    setExam(val) {
      this.$emit('set' , val)
    },
  }
}
</script>

<style>
.text {
  font-size: 14px;
  max-width: 400px;
  line-height: 1.5;
}
</style>
